import React from "react";
import styles from "./Footer.module.scss";
import { Container } from "react-grid-system";
import { useCommunity } from "../../context/community";
import { useHistory } from "react-router-dom";
import { PAGES } from "../../routes/PAGES";
import Logo from 'components/Logo/Logo';
import LangService from "services/LangService";
import { useServerProperties } from "services/server-properties";
import FooterSocialLinks from "./FooterSocialLinks";

const SHOULD_BE_HIDDEN = [
  PAGES.LOGIN,
  PAGES.REGISTRATION,
  PAGES.RECOVERY,
  PAGES.CONFIRM_RECOVERY,
  PAGES.QUESTIONS,
  PAGES.ONBOARDING,
  PAGES.LAST_STEP,
  PAGES.CONFIRMED,
  PAGES.AUTH_MAGIC,
];


const DEFAULT_FOOTER = {
  isHidden: false,
  registration: null,
  contact: null,
  links: [{
    url: 'https://linkedin.com',
    icon: "linkedin"
  }, {
    url: 'https://facebook.com',
    icon: "facebook"
  }, {
    url: 'https://twitter.com',
    icon: "twitter"
  }]
}

const mergeFooters = (footer = {}) => {
  let mergedFooter = {};
  Object.keys(DEFAULT_FOOTER).forEach(key => {
    if (footer.hasOwnProperty(key) && footer[key] !== null) {
      mergedFooter[key] = footer[key];
    } else {
      mergedFooter[key] = DEFAULT_FOOTER[key];
    }
  });
  return mergedFooter;
}

const Footer = ({ shortLandingFooter }) => {
  const langMap = LangService.map.pages.welcome;
  const history = useHistory();
  const { docs } = useServerProperties();
  const { community: { domain, brandConfig, shortLanding, senderEmail, footerSocialLinks, copyrightHidden, footerHidden, isTimCommunity } } = useCommunity();
  const isLanding = history.location.pathname === PAGES.WELCOME;
  const mergedFooter = mergeFooters(shortLandingFooter);


  // Hide footer on some pages
  if (SHOULD_BE_HIDDEN.includes(history.location.pathname)) {
    return null;
  }


  // Per domain footer
  if (domain == "connect-entire") {
    return (
      <footer>
        <Container className={styles.footer}>
          <ul>
            <li>
              <a href="https://my.entire.vc/" target="_blank">Entire VC</a>
            </li>
            <li>
              <a href="https://events.entire.vc/" target="_blank">Events</a>
            </li>
            <li>
              <a href="https://my.entire.vc/network/" target="_blank">Network</a>
            </li>
            <li>
              <a href="https://my.entire.vc/kb/" target="_blank">Knowledge</a>
            </li>
          </ul>
        </Container>
      </footer>
    );
  }


  // Separate logic for short landing
  if (isLanding && shortLanding) {

    if (!shortLandingFooter) {
      return null;
    }

    return (
      <footer>
        <Container>
          <div className={styles.shortLanding}>
            {!footerHidden && <div className={styles.footerLinks}>
              <div className={styles.brand}>
                <span>RUN BY</span>
                <div>
                  <Logo brand={brandConfig} />
                </div>
              </div>
              <div className={styles.links}>
                <ul>
                  <li>
                    <a
                      className={isTimCommunity ? styles.timLaunchLink : ""}
                      href={brandConfig.launchUrl}
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      {langMap.about.launchLink}
                    </a>
                  </li>
                  <li>
                    <a href={brandConfig.siteUrl}>main</a>
                  </li>
                  <li>
                    <a
                      href={docs.policyUrl}
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Privacy policy
                    </a>
                  </li>
                  <li>
                    <a
                      href={"mailto:" + senderEmail}
                      target={"_blank"}
                      rel="noreferrer"
                    >
                      Contact us
                    </a>
                  </li>
                </ul>
              </div>
              <FooterSocialLinks
                landingJsonParsedFooter={mergedFooter}
                communityFooterLinks={footerSocialLinks} />
            </div>}
            {!copyrightHidden &&
              <div className={styles.copyright}>
                {`Copyright © ${new Date().getFullYear()} `}
                <a href={brandConfig.siteUrl} target="_blank">
                  {brandConfig.title}
                </a>
                . All Rights Reserved
              </div>}
          </div>
        </Container>
      </footer>
    );
  }


  // Empty footer
  if (copyrightHidden) {
    return (
      <footer style={{ paddingTop: '2rem' }}>
      </footer>
    );
  }


  // Default footer
  return (
    <footer>
      <Container className={styles.footer}>
        {`Copyright © ${new Date().getFullYear()} `}
        <>
          <a href={brandConfig.siteUrl} target="_blank">
            <strong>{brandConfig.title}</strong>
          </a>
          . All Rights Reserved
        </>
      </Container>
    </footer >
  );
};

export default Footer;
